export default __webpack_public_path__ + "static/media/project_version_control.579debcd.png";